import React from 'react'
import './styles.css'
import Imgcultura from '../../img/bgarea.jpg'

const Cultura = () =>{
    return(
        <div className="content-area">
        <div id="bg-area"></div>

            <div id="title-link">
            <h1>LISTA CULTURAL DE ITANHAÉM</h1><br/>
            </div>
        <div className="link-area">
            <div className="link-1">
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/aulas-de-danca/" target="_blank">Aulas de Dança</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/banda-marcial-de-itanhaem/" target="_blank">Banda Marcial</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/biblioteca-municipal-poeta-paulo-bomfim/" target="_blank">Biblioteca Municipal</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/caminhos-culturais/" target="_blank">Caminhos Culturais</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/casa-da-musica/" target="_blank">Casa da Música</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/circuito-cultural-paulista/" target="_blank">Circuito Cultural Paulista</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/educando-para-o-transito/" target="_blank">Educando Para o Trânsito</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/escola-vai-ao-cinema/" target="_blank">Escola Vai ao Cinema</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/espaco-gabinete-de-leitura/" target="_blank">Espaço Gabinete de Leitura</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/fanfarra-nas-escolas/" target="_blank">Fanfarra nas escolas</a></li><br/>
            </div>
            <div className="vdivisor"></div>
            <div className="link-2">
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/iniciacao-cultural/" target="_blank">Iniciação Cultural</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/museu-conceicao-de-itanhaem/" target="_blank">Museu Conceição de Itanhaém</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/oficinas-culturais/" target="_blank">Oficinas Culturais</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/oficinas-pagu/" target="_blank">Oficinas Pagu</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/pinacoteca-municipal/" target="_blank">Pinacotteca Municipal</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/pontos-mis/" target="_blank">Pontos MIS</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/revelando-sao-paulo/" target="_blank">Revelando São Paulo</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/siseb/" target="_blank">SISEB</a></li><br/>
                <li><a href="http://www2.itanhaem.sp.gov.br/educacao/viagem-literaria/" target="_blank">Viagem Literária</a></li><br/>
            </div>
            <img id="imgcultura" src={Imgcultura} alt=""/>
            </div>
        </div>
    )
}

export default Cultura